import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { CategoryContext } from '../context/CategoryContext.js';
import "../assest/Sidebar.css";
import { ProductContext } from '../context/ProductContext.js';
import { FaBars, FaTimes, FaChevronDown, FaChevronRight, FaSort } from 'react-icons/fa';

const Sidebar = () => {
    const { state: categoryState, selectedCategory } = useContext(CategoryContext);
    const { categories, loading, error } = categoryState;
    const [openCategories, setOpenCategories] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sort = searchParams.get('sort') || "newest";

    const toggleCategory = (categoryId) => {
        if (openCategories.includes(categoryId)) {
            setOpenCategories(openCategories.filter((id) => id !== categoryId));
            setActiveCategory(null);
        } else {
            setOpenCategories([...openCategories, categoryId]);
            setActiveCategory(categoryId);
        }
        selectedCategory(categoryId);
    };

    const handleCategoryHover = (categoryId, isEnter) => {
        if (window.matchMedia("(hover: hover)").matches) {
            if (isEnter) {
                setActiveCategory(categoryId);
            } else {
                if (openCategories.includes(categoryId)) {
                    return;
                }
                setActiveCategory(null);
            }
        }
    };

    const ustKategoriler = categories.filter((kategori) => kategori.ust_kategori === 0 & kategori.ust_menu === 1);

    const hasSubcategories = (categoryId) => {
        return categories.some((kategori) => kategori.ust_kategori === categoryId);
    };

    const handleSortChangeWithRedirect = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue === "price_asc") {
            navigate(`?sort=price_asc`);
            window.location.reload();
        } else if (selectedValue === "price_desc") {
            navigate(`?sort=price_desc`);
            window.location.reload();
        } else {
            navigate(`?sort=newest`);
            window.location.reload();
        }
    };

    if (loading) return <div className="d-flex justify-content-center py-4"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Yükleniyor...</span></div></div>;
    if (error) return <div className="alert alert-danger">Hata: {error}</div>;

    return (
        <>
            <div className="mobile-sidebar-header d-md-none d-flex justify-content-between align-items-center mb-0">
                <div className="sidebar-toggle d-md-none d-flex align-items-center rounded">
                    <button 
                        className="btn d-flex align-items-center shadow-none border-0" 
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    >
                        {isSidebarOpen ? 
                            <FaTimes className="me-2 sidebar-icon" /> : 
                            <FaBars className="me-2 sidebar-icon" />
                        }
                        <span className="fw-medium sidebar-header-title">Kategoriler</span>
                    </button>
                </div>
                {/* <div className="sort-dropdown-mobile d-md-none">
                    <select 
                        id="sortOrderMobile" 
                        className="form-select form-select-sm" 
                        value={sort} 
                        onChange={handleSortChangeWithRedirect}
                    >
                        <option value="newest">En Yeni</option>
                        <option value="price_asc">Artan Fiyat</option>
                        <option value="price_desc">Azalan Fiyat</option>
                    </select>
                </div> */}
            </div>

            {/* <div className="sort-dropdown-desktop d-none d-md-block mb-3">
                <div className="d-flex align-items-center">
                    <FaSort className="me-2 text-primary" />
                    <select 
                        id="sortOrderDesktop" 
                        className="form-select" 
                        value={sort} 
                        onChange={handleSortChangeWithRedirect}
                    >
                        <option value="newest">En Yeni</option>
                        <option value="price_asc">Artan Fiyata Göre</option>
                        <option value="price_desc">Azalan Fiyata Göre</option>
                    </select>
                </div>
            </div> */}

            <div className={`card border-0 shadow-sm rounded-3 overflow-hidden sidebar-card p-0 ${isSidebarOpen ? 'sidebar-open' : 'd-none d-md-block'}`}>
                <div className="card-header text-white py-3 border-bottom">
                    <h5 className="card-title mb-0 fw-bold sidebar-title">Kategoriler</h5>
                </div>
                <div className="card-body p-0">
                    <div className="list-group list-group-flush">
                        {ustKategoriler.map((kategori) => (
                            <div 
                                key={kategori.id} 
                                className={`sidebar-category ${activeCategory === kategori.id ? 'active' : ''} ${openCategories.includes(kategori.id) ? 'opened' : ''}`}
                            >
                                <a 
                                    href={`${kategori.sef}`}
                                    className={`list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center py-3 px-3 ${activeCategory === kategori.id ? 'active-category' : ''}`}
                                    onClick={(e) => {
                                        if (hasSubcategories(kategori.id)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onMouseEnter={() => handleCategoryHover(kategori.id, true)}
                                    onMouseLeave={() => handleCategoryHover(kategori.id, false)}
                                >
                                    <span className="category-title" onClick={(e) => {
                                        if (hasSubcategories(kategori.id)) {
                                            e.stopPropagation();
                                            window.location.href = `${kategori.sef}`;
                                        }
                                    }}>{kategori.baslik}</span>
                                    {hasSubcategories(kategori.id) && (
                                        <span 
                                            className="ms-2 dropdown-icon"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                toggleCategory(kategori.id);
                                            }}
                                        >
                                            {openCategories.includes(kategori.id) ? 
                                                <FaChevronDown size={12} /> : 
                                                <FaChevronRight size={12} />
                                            }
                                        </span>
                                    )}
                                </a>
                                
                                {hasSubcategories(kategori.id) && (
                                    <div 
                                        className={`subcategory-list ${openCategories.includes(kategori.id) ? 'opened' : ''}`}
                                        style={{
                                            maxHeight: openCategories.includes(kategori.id) ? '1000px' : '0'
                                        }}
                                    >
                                        {categories
                                            .filter((altKategori) => altKategori.ust_kategori === kategori.id)
                                            .map((altKategori, index) => (
                                                <a 
                                                    key={altKategori.id}
                                                    href={`${altKategori.sef}`}
                                                    className="list-group-item list-group-item-action border-0 ps-4 py-2"
                                                >
                                                    {altKategori.baslik}
                                                </a>
                                            ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
